import { render, staticRenderFns } from "./WebResourcesController.vue?vue&type=template&id=a452c6ea&scoped=true"
import script from "./WebResourcesController.vue?vue&type=script&lang=ts"
export * from "./WebResourcesController.vue?vue&type=script&lang=ts"
import style0 from "./WebResourcesController.vue?vue&type=style&index=0&id=a452c6ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a452c6ea",
  null
  
)

export default component.exports